import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const ProtectedRoutes = () => {
  const user = useSelector((state) => state?.user?.value);
  const navigate = useNavigate();
  const location = useLocation();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const authenticatedUser = user || localStorage.getItem("userId");

  useEffect(() => {
    if (!authenticatedUser) {
      const searchParams = new URLSearchParams(location.search);
      const queryParams = searchParams.toString();
      const pathWithParams = location.pathname + (queryParams ? `?${queryParams}` : '');
      const useLegacyLogin = location.pathname === '/tv';
      navigate(
        useLegacyLogin || projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED !== "true"
          ? '/login'
          : '/checkout',
        {
          state: {
            path: pathWithParams,
            activeLogin: true,
            useLegacyLogin,
          },
        }
      );
    }
  }, [authenticatedUser, navigate, location]);

  if (authenticatedUser) {
    return <Outlet />;
  } else {
    return null;
  }
};

export default ProtectedRoutes;